import {
  CMBoxcontainer,
  CMOffer,
  CMLiveTag,
  CMBoxContent,
  CMBoxPrice,
  CMDescription,
  CMButton,
  CMListsTable,
  CMTtileColumn,
} from "./auction-book.styles";
import Table from "../../table/table.component";
import Button, { BUTTON_TYPE_CLASSES } from "../../button/button.component";
import Progress, { PROGRESS_TYPE} from "../../progress/progress.component";
import { useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { useAuth } from "../../../Contexts/auth.context";
import { fetchBids, getAuctionDetails } from "../../../Services/auction.service";
import Countdown from "../../countdown/countdown.component";
import { useParams } from "react-router-dom";
import LoadingChild from "../../loading-child/loading-child.component";

const AuctionBook = ({ handleNext, handleClose }) => {
  const isMobile = useMediaQuery("(max-width:992px)");
  const initialRows = [];
  const [listing, setListing] = useState(initialRows);
  const [loading, setLoading] = useState(true);
  const [auction, setAuction] = useState();
  const { auth } = useAuth();
  const { order } = useParams();
  const urlParams = new URLSearchParams(window.location.search);
  const idParam = urlParams.get('id');

  useEffect(() => {

    if (auth && auth.userId) {
      fetchBids(idParam).then(response => {
        if (response.ok) {
          return response.json();
        }
        else {
          throw new Error('Exception getting Bids');
        }
        //console.log(response);
        //setListing(response);
      }).then(data => {
        console.log(data);
        setListing(data);
      }).catch(err => {
        console.log(err);
      })


      getAuctionDetails(idParam, auth.userId)
        .then((response) => {
          if (response) {
            setAuction(response);
          }
        })
        .catch((err) => console.error(err))
        .finally(() => setLoading(false));
    }

  }, []);

  const unitBalanceFields = [
    {
      field: "date",
      headerName: "",
      flex: 1,
      //minWidth: 250,
      sortable: false, // optional: disable sorting functionality
      disableColumnMenu: true,
    },
    /*{
      field: "FullName",
      headerName: "Name",
      minWidth: 250,
      sortable: false, 
      disableColumnMenu: true,
    },*/
    {
      field: "bid_per_unitStr",
      headerName: "Price per unit",
      flex: 0.5, // width of "Price per unit"
      //minWidth: 100,
      sortable: false,
      disableColumnMenu: true,
      align: "right", // Align content to right
      headerAlign: "right", // Align header to right
      /*headerClassName: "headerCell",*/
      /*renderCell: PricePerUnit,*/
      /*headerAlign: "center",*/
    },
  ];
  const hiddenColumns = {};
  return (
    <>
    {loading ?
          <div style={{paddingTop:"30%",paddingBottom:"30%"}}>
          <LoadingChild /> 
          </div>
          :
        <>
          <CMBoxcontainer className="dotted-border">
            <CMLiveTag>LIVE</CMLiveTag>
            <CMBoxContent>
              <div className="left-column">
                <h3>{auction?.symbol}</h3>
                <h5>{auction?.assetName}</h5>
              </div>
              <div className="right-column">
                <h4>Live auction ends in</h4>
                <h4 className="liveAuctionColor">
                  <Countdown date={auction?.endDate} />

                </h4>
              </div>
            </CMBoxContent>
            <CMBoxPrice>
              <div className="left-column">
                <h5>Target price per unit</h5>
                <h5>{auction?.targetPricePerUnit}</h5>

              </div>
              <div className="right-column">
                <h5>Current auction price per unit</h5>
                <h5>{auction?.CurrentAuctionPrice}</h5>
              </div>
            </CMBoxPrice>
          </CMBoxcontainer>
          <CMBoxcontainer className="dotted-border">
            <CMDescription>
              <div className="left-column">
                <h5>Average bid price</h5>
                <h5>{auction?.AverageBid}</h5>
              </div>
              {/* <div className="middle-column">
            <h5>Median bid price</h5>
            <h5>$ 22.60</h5>
          </div> */}
              <div className="right-column">
                <h5>Bided units</h5>
                <h5>{auction?.BidedUnits} </h5>
              </div>
            </CMDescription>
            <CMButton>
              <Button onClick={handleNext}>Make an offer</Button>
              <Progress
                progressType={PROGRESS_TYPE.linear}
                value={auction.progress}
              />
            </CMButton>

          </CMBoxcontainer>
          <CMListsTable className="CMTableTop">
            <Table
              rows={listing}
              columns={unitBalanceFields}
              pageSize={4}
              autoHeight
              hiddenColumns={isMobile ? hiddenColumns : []}
            />
          </CMListsTable>
        </>
}
    </>
  );
};
export default AuctionBook;
